import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { type FrontRoyalRootScope } from 'FrontRoyalAngular';
import type ClientStorageType from 'ClientStorage';
import { angularInjectorProvider } from 'Injector';

const buildCurrentUrl = ({ pathname, search, hash }: { pathname: string; search: string; hash: string }): string =>
    `${pathname}${search}${hash}`;

export function useTrackLastVisitedRoute(): void {
    const location = useLocation();

    useEffect(() => {
        const injector = angularInjectorProvider.injector;
        if (!injector) return;

        const $window = injector.get('$window');
        const $rootScope = injector.get<FrontRoyalRootScope>('$rootScope');

        if (!$window?.CORDOVA || !$rootScope?.currentUser) {
            return;
        }

        const ClientStorage = injector.get<typeof ClientStorageType>('ClientStorage');
        const currentUrl = buildCurrentUrl(location);
        ClientStorage.setItem('last_visited_route', currentUrl);
    }, [location]);
}
